import { NavigationEnd } from '@angular/router';
import { createSelector } from '@ngrx/store';

import { AutoPaySetupSelectors, AutoPaySteps } from '@amfam/billing/auto-pay/feature';
import { BillAccountsSelectors } from '@amfam/billing/billaccount/data-access';

import { Breadcrumb } from '../shared-ui-breadcrumb.module';

export const selectSetBreadcrumbColorBlue = (breadcrumb: Breadcrumb | NavigationEnd) =>
  createSelector(
    BillAccountsSelectors.selectIsSelectedBillPolicyHomesite,
    AutoPaySetupSelectors.selectActiveStep,
    (isHomesitePolicy, activeStep) =>
      /^\/\/billing\/\d{11}$/.test(breadcrumb?.url) ||
      (isHomesitePolicy && activeStep === AutoPaySteps.CONFIRMATION)
  );

export const breadcrumbSelectors = {
  selectSetBreadcrumbColorBlue
};
